module.exports = __webpack_public_path__ + "static/img/cont2301.aabe484.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2301.jpg
// module id = blim
// module chunks = 0